import { ProviderName } from '../../account/models/login-response.model';

export class ExternalConnect {
  jwt: string;
  providerId: ProviderName;
  redirectUrl: string;

  constructor(jwt: string, provider: ProviderName = ProviderName.TicketMaster, redirectUrl: string = '') {
    this.jwt = jwt;
    this.providerId = provider;
    this.redirectUrl = redirectUrl;
  }
}
